import React from "react";
import axios from "axios";
import constant from "../../constant";
import CountrylistComp from "../../components/CountrylistComp";
import CitylistComp from "../../components/CitylistComp";
import "./style.scss";

export default class Step3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      instant_checked: false,
      title_v: "",
      spacetypes: "1",
      spacetype_list: [],
      no_of_desk: "1",
      isLongterm: false,
      long_term: "5days",
      cost_v: "0",
      currencys: 1,
      currency_code: "EUR",
      currency_list: [],
      search_address: "",
      address: "",
      country_id: "0",
      city_id: "0",
      zip_v: "",
      description_v: "",
      is_alldays_checked: false,
      checkAll_oh: false,
      time_list: [],
      f_time: "09:00",
      t_time: "17:00",
      cf_time: ["09:00", "09:00", "09:00", "09:00", "09:00", "09:00", "09:00"],
      ct_time: ["17:00", "17:00", "17:00", "17:00", "17:00", "17:00", "17:00"],
      day_checked: [false, false, false, false, false, false, false],
      checkall: true,
      amenity_list: [],
      amenity_checked: [],
      days: [],
      discount_count: 0,
      id: 0,
      space_sub_list: [],
      space_sub_checked: [],
      errors: {},
      latitude: 0,
      longitude: 0
    };
  }

  componentDidMount() {
    let local_storage_step2 = JSON.parse(
      localStorage.getItem(this.props.spaceId)
    );
    if (
      local_storage_step2 &&
      local_storage_step2["id"] === this.props.spaceId
    ) {
      local_storage_step2 &&
        Object.keys(local_storage_step2).reduce((object, key) => {
          return this.setState({
            [key]: local_storage_step2[key]
          });
        }, {});
    } else {
      localStorage.removeItem(this.props.spaceId);
    }

    // Initialize to fill data
    this.initiateFillData();

    if (this.props.listing === "edit") {
      this.getEditListing();
    } else {
      this.SearchInMap();
    }
  }

  initiateFillData() {
    let _this = this;
    let spaceId = this.props.spaceId;

    axios
      .get(`${constant.phpHost}action/listing.php`, {
        params: {
          todo: "getAllDataSpace_Step2",
          spaceId: spaceId
          // space_type_id: this.state.spacetypes
        }
      })
      .then(res => {
        // console.log(res);
        _this.setState({
          spacetype_list: res.data.spacetype_list,
          currency_list: res.data.currency_list,
          amenity_list: res.data.amenity_list,
          time_list: res.data.time_list,
          days: res.data.days,
          // space_sub_list: res.data.space_sub_list,
          discount_count: res.data.discount_count,
          id: this.props.spaceId
        });
      });
  }

  getEditListing() {
    let _this = this;
    localStorage.removeItem(this.props.spaceId);

    axios
      .get(`${constant.phpHost}action/listing.php`, {
        params: {
          todo: "get_particular_listing_step2",
          spaceId: this.props.spaceId,
          user_id: this.props.user_id
        }
      })
      .then(res => {
        res.data &&
          Object.keys(res.data).reduce((object, key) => {
            return this.setState({
              [key]: res.data[key]
            });
          }, {});

        _this.SearchInMap();
      });
  }

  delete_discount() {
    axios
      .get(`${constant.phpHost}action/listing.php`, {
        params: {
          todo: "Del_dis",
          en_id: this.props.spaceId
        }
      })
      .then(res => {
        // console.log("success");
      });
  }

  // Enable instant booking
  handleCheck = (e, field) => {
    let fields = this.state;
    let checked = e.target.checked;

    if (field === "isLongterm") {
      if (this.state.discount_count > 0) {
        if (
          window.confirm(
            "There is no discount price in the long term rent. Do you want to continue? "
          )
        ) {
          fields[field] = checked;
          this.setState({ fields });

          this.delete_discount();

          // Reset discount count
          this.initiateFillData();
        }
      } else {
        fields[field] = checked;
        this.setState({ fields });
      }
    } else if (field === "space_sub_checked") {
      let { space_sub_checked } = this.state;

      let index = space_sub_checked.indexOf(e.target.value);

      if (index !== -1) {
        space_sub_checked.splice(index, 1);
        this.setState({ space_sub_checked });
      } else {
        this.setState({
          space_sub_checked: [...space_sub_checked, e.target.value]
        });
      }
    } else {
      fields[field] = checked;
      this.setState({ fields });
    }
  };

  handleChange = (e, field) => {
    let fields = this.state;
    let value = e.target.value;

    if (field === "spacetypes" || field === "cost_v") {
      if (this.state.discount_count > 0) {
        if (
          window.confirm(
            `If you change the ${field} your already added discounts will be lost. Do you want to continue?`
          )
        ) {
          if (field === "spacetypes") {
            fields[field] = value;
            this.setState({ fields, space_sub_checked: [] });
          } else {
            fields[field] = value;
            this.setState({ fields });
          }

          this.delete_discount();
          alert("you can add discount price in the next step");
        }
      } else {
        if (field === "spacetypes") {
          fields[field] = value;
          this.setState({ fields, space_sub_checked: [] });
        } else {
          fields[field] = value;
          this.setState({ fields });
        }
      }

      // Reset discount count
      this.initiateFillData();
    } else {
      fields[field] = value;
      this.setState({ fields });
    }

    if (field === "currencys") {
      let currency_code = e.target[e.target.selectedIndex].getAttribute("code");
      this.setState({ currency_code });
    }
  };

  // Autofill search address
  SearchInMap = () => {
    let _this = this;

    const google = window.google;

    var componentForm = {
      street_number: "short_name",
      route: "long_name",
      locality: "long_name",
      administrative_area_level_1: "short_name",
      country: "long_name",
      postal_code: "short_name"
    };

    var input = document.getElementById("search_address");
    var geocoder;
    var search_address;
    var myLatLng = {
      lat: parseFloat(this.state.latitude),
      lng: parseFloat(this.state.longitude)
    };

    geocoder = new google.maps.Geocoder();
    var map = new google.maps.Map(document.getElementById("map"), {
      center: myLatLng,
      zoom: 13
    });

    search_address = new google.maps.places.Autocomplete(input);

    search_address.bindTo("bounds", map);
    var marker = new google.maps.Marker({
      position: myLatLng,
      map: map,
      anchorPoint: new google.maps.Point(0, -29),
      draggable: true
    });

    search_address.addListener("place_changed", function() {
      marker.setVisible(false);
      var place = search_address.getPlace();

      if (!place.geometry) {
        window.alert("No details available for input: '" + place.name + "'");
        return;
      }

      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);
      }
      marker.setPosition(place.geometry.location);
      marker.setVisible(true);

      var address = "";
      if (place.address_components) {
        address = [
          (place.address_components[0] &&
            place.address_components[0].short_name) ||
            "",
          (place.address_components[1] &&
            place.address_components[1].short_name) ||
            "",
          (place.address_components[2] &&
            place.address_components[2].short_name) ||
            ""
        ].join(" ");
      }

      document.getElementById("latitude").value = place.geometry.location.lat();
      document.getElementById(
        "longitude"
      ).value = place.geometry.location.lng();

      fillInAddress();

      getCityCountryID(address, place);
    });

    function fillInAddress(new_address) {
      if (typeof new_address == "undefined") {
        var place = search_address.getPlace(input);
      } else {
        place = new_address;
      }

      for (var component in componentForm) {
        document.getElementById(component).value = "";
        document.getElementById(component).disabled = false;
      }

      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
          var val = place.address_components[i][componentForm[addressType]];
          document.getElementById(addressType).value = val;
        }
      }
    }

    google.maps.event.addListener(marker, "dragend", function() {
      geocoder.geocode(
        {
          latLng: marker.getPosition()
        },
        function(results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              // console.log(search_address);
              document.getElementById("search_address").value =
                results[0].formatted_address;
              document.getElementById(
                "latitude"
              ).value = marker.getPosition().lat();
              document.getElementById(
                "longitude"
              ).value = marker.getPosition().lng();

              fillInAddress(results[0]);

              var address = "";
              if (results[0].address_components) {
                address = [
                  (results[0].address_components[0] &&
                    results[0].address_components[0].short_name) ||
                    "",
                  (results[0].address_components[1] &&
                    results[0].address_components[1].short_name) ||
                    "",
                  (results[0].address_components[2] &&
                    results[0].address_components[2].short_name) ||
                    ""
                ].join(" ");
              }

              getCityCountryID(address, results[0]);
            }
          }
        }
      );
    });

    function getCityCountryID(address, places) {
      axios
        .get(`${constant.phpHost}action/listing.php`, {
          params: {
            todo: "change_place",
            city: document.getElementById("locality").value,
            country: document.getElementById("country").value
          }
        })
        .then(res => {
          if (res.data && res.data != null) {
            _this.setState({
              country_id: res.data.country_id ? res.data.country_id : "0",
              city_id: res.data.city_id ? res.data.city_id : "0",
              search_address: document.getElementById("search_address").value,
              latitude: document.getElementById("latitude").value,
              longitude: document.getElementById("longitude").value,
              address: address,
              // street_no: document.getElementById("street_number").value,
              zip_v: document.getElementById("postal_code").value
            });
          }
        });
    }
  };

  // Country id from country component
  handleCountry = country_id => {
    this.setState({
      country_id: country_id,
      city_id: 0
    });
  };

  // City id from city component
  handleCity = city_id => {
    this.setState({
      city_id: city_id
    });
  };

  // checkbox days
  handleCheckDays(e, check) {
    let day_checked = this.state.day_checked;

    // check all days
    if (check === "check_all") {
      for (var i = 0; i <= 6; i++) {
        day_checked[i] = !this.state.checkAll_oh;
      }

      this.setState({
        day_checked,
        checkAll_oh: !this.state.checkAll_oh
      });
    }

    // check each days
    if (check === "check_index") {
      let i = e.target.getAttribute("index");
      let checkAll_oh;

      day_checked[i] = !day_checked[i];

      if (day_checked.indexOf(false) === -1) {
        checkAll_oh = true;
      } else {
        checkAll_oh = false;
      }

      this.setState({
        day_checked,
        checkAll_oh
      });
    }
  }

  // Select day hours
  handleCheckDayHours(e, field) {
    const { cf_time, ct_time } = this.state;
    let changedTime;

    // change all day hours
    if (field === "f_time" || field === "t_time") {
      const fields = this.state;

      fields[field] = e.target.value;

      for (var i = 0; i <= 6; i++) {
        if (field === "f_time") {
          cf_time[i] = e.target.value;
          changedTime = cf_time;
        } else {
          ct_time[i] = e.target.value;
          changedTime = ct_time;
        }
      }

      this.setState({ changedTime, fields });
    }

    // change each day hours
    if (field === "from" || field === "to") {
      const i = e.target.getAttribute("index");

      if (field === "from") {
        cf_time[i] = e.target.value;
        changedTime = cf_time;
      } else {
        ct_time[i] = e.target.value;
        changedTime = ct_time;
      }

      this.setState({ changedTime });
    }
  }

  // Amenity check
  handleCheckAmenity = (e, field) => {
    let { amenity_checked } = this.state;
    let check_ = document.getElementsByClassName("amenity");

    // change all amenity
    if (field === "check_all") {
      if (e.target.checked) {
        for (let i = 0; i < check_.length; i++) {
          amenity_checked[i] = check_[i].value;
        }
      } else {
        amenity_checked = [];
      }

      this.setState({
        amenity_checked,
        checkAll: e.target.checked
      });
    }

    // change each amenity
    if (field === "check_each") {
      let index = amenity_checked.indexOf(e.target.value);

      if (amenity_checked.length + 1 === check_.length) {
        this.setState({ checkAll: true });
      }

      if (index !== -1) {
        amenity_checked.splice(index, 1);
        this.setState({ amenity_checked, checkAll: false });
      } else {
        this.setState({
          amenity_checked: [...amenity_checked, e.target.value]
        });
      }
    }
  };

  // Form Validation
  list_validation = () => {
    let fields = this.state;
    let errors = {};
    let formIsValid = true;
    let regularExpression = /^[0-9]+$/;
    let regularExpressionCost = /^[0-9.,]+$/;

    if (!fields["title_v"]) {
      formIsValid = false;
      errors["title_v"] = "Enter title of the venue";
    }

    if (fields["no_of_desk"] === 0) {
      formIsValid = false;
      errors["no_of_desk"] = "Enter desk availability";
    }

    if (!regularExpression.test(fields["no_of_desk"])) {
      formIsValid = false;
      errors["no_of_desk"] = "Enter valid desk count";
    }

    if (fields["cost_v"] === "0") {
      formIsValid = false;
      errors["cost_v"] = "Enter price";
    }

    if (!regularExpressionCost.test(fields["cost_v"])) {
      formIsValid = false;
      errors["cost_v"] = "Enter valid price";
    }

    if (!fields["search_address"]) {
      formIsValid = false;
      errors["search_address"] = "Choose your address";
    }

    if (!fields["address"]) {
      formIsValid = false;
      errors["address"] = "Enter your address";
    }

    if (fields["country_id"] === "0") {
      formIsValid = false;
      errors["country_id"] = "Select country";
    }

    if (fields["city_id"] === "0") {
      formIsValid = false;
      errors["city_id"] = "Select city";
    }

    if (!fields["zip_v"]) {
      formIsValid = false;
      errors["zip_v"] = "Enter zip code";
    }

    if (!regularExpression.test(fields["zip_v"])) {
      formIsValid = false;
      errors["zip_v"] = "Enter valid zip";
    }

    if (!fields["description_v"]) {
      formIsValid = false;
      errors["description_v"] = "Enter description of venue and space ";
    }

    if (fields["amenity_checked"].length === 0) {
      formIsValid = false;
      errors["vcheckbox"] = "Select atleast one amenity";
    }

    if (
      fields["is_alldays_checked"] === false &&
      fields["day_checked"].length === 0
    ) {
      formIsValid = false;
      errors["vcheckhours"] = "Select atleast one day";
    }

    this.setState({ errors: errors });
    if (!formIsValid) {
      window.scrollTo(0, 0);
    }
    return formIsValid;
  };

  // Previous and Next Button
  buttonStep = step => {
    if (step === "prev") {
      this.props.stepButton(2);
    } else {
      if (this.list_validation()) {
        // Setting state data to local storage
        const remove_state_field = [
          "errors",
          "fields",
          "currency_list",
          "time_list"
        ];

        let step2 = Object.keys(this.state).reduce((object, key) => {
          if (remove_state_field.indexOf(key) <= -1) {
            object[key] = this.state[key];
          }
          return object;
        }, {});

        localStorage.setItem(this.props.spaceId, JSON.stringify(step2));

        // Price discount currency change
        let local_storage_step2 = JSON.parse(
          localStorage.getItem(this.props.spaceId)
        );

        axios
          .get(`${constant.phpHost}action/listing.php`, {
            params: {
              todo: "price_discount_update",
              desk_id: this.props.spaceId,
              currency_id: local_storage_step2["currencys"]
            }
          })
          .then(res => {});

        // Next button step
        this.state.isLongterm
          ? this.props.stepButton(5)
          : this.props.stepButton(4);
      }
    }
  };

  render() {
    const { errors, long_term } = this.state;

    function error(name) {
      if (errors[name]) {
        return <p className="error">{errors[name]}</p>;
      }
    }

    return (
      <div>
        <h3 className="heading"> Add Informations </h3>

        <div className="add_info_block">
          <div className="form-group inst_booking">
            <label className="check_list">
              <input
                type="checkbox"
                onChange={e => this.handleCheck(e, "instant_checked")}
                checked={this.state.instant_checked ? "checked" : ""}
              />
              <span className="checkmark" />
              Do you want to enable <b> instant booking? </b>
            </label>
          </div>

          <div className="form-group">
            <label>
              What will be the title of this venue? <b>*</b>
            </label>

            <input
              type="text"
              onChange={e => this.handleChange(e, "title_v")}
              value={this.state.title_v}
              placeholder="Eg. Heydesk workspace"
            />
            {error("title_v")}
            <span>
              <b>Hint:</b> Try to keep it as short and simple as possible.
            </span>
          </div>

          <div className="col_6">
            <div className="form-group">
              <label>What type of space is this?</label>
              <select
                value={this.state.spacetypes}
                onChange={e => this.handleChange(e, "spacetypes")}
              >
                {this.state.spacetype_list.map((spacetype, i) => (
                  <option key={i} value={spacetype.id}>
                    {spacetype.title}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>
                How many
                {this.state.spacetypes > 1
                  ? " participants"
                  : " desk available"}
                <b> * </b>
              </label>

              <input
                type="text"
                onChange={e => this.handleChange(e, "no_of_desk")}
                value={this.state.no_of_desk}
              />
              {error("no_of_desk")}
            </div>
          </div>
          {this.state.space_sub_list &&
            this.state.space_sub_list.map((space_sub, i) => (
              <div className="form-group" key={i}>
                <label className="check_list space_sub">
                  <input
                    type="checkbox"
                    onChange={e => this.handleCheck(e, "space_sub_checked")}
                    value={space_sub.id}
                    checked={
                      this.state.space_sub_checked.includes(space_sub.id)
                        ? "checked"
                        : ""
                    }
                  />
                  <span className="checkmark" />
                  {space_sub.title}
                </label>
              </div>
            ))}

          <hr />

          <div className="form-group">
            <label className="check_list">
              <input
                type="checkbox"
                onChange={e => this.handleCheck(e, "isLongterm")}
                checked={this.state.isLongterm ? "checked" : ""}
              />
              <span className="checkmark" />
              Yes, I only want to rent out on <b> longer terms.</b>
            </label>
          </div>
          {this.state.isLongterm ? (
            <div className="col_4">
              <div className="form-group">
                <label>Term Period</label>
                <select
                  onChange={e => this.handleChange(e, "long_term")}
                  value={long_term}
                >
                  <option value="5days">5 days minimun</option>
                  <option value="2weeks">2 weeks minimun</option>
                  <option value="1month">1 month minimun</option>
                  <option value="3months">3 months minimun</option>
                </select>
              </div>

              <div className="form-group">
                <label>Cost per {long_term}</label>
                <input
                  type="number"
                  onChange={e => this.handleChange(e, "cost_v")}
                  value={this.state.cost_v}
                />
                {error("cost_v")}
              </div>

              <div className="form-group">
                <label>Select currency</label>
                <select
                  value={this.state.currencys}
                  code={this.state.currency_code}
                  onChange={e => this.handleChange(e, "currencys")}
                >
                  {this.state.currency_list.map((currency, i) => (
                    <option key={i} value={currency.id} code={currency.code}>
                      {currency.code}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ) : (
            <div className="col_6">
              <div className="form-group">
                <label>
                  Cost per
                  {this.state.spacetypes > 1 ? " hour?" : " day?"}
                  <b> * </b>
                </label>

                <input
                  type="number"
                  onChange={e => this.handleChange(e, "cost_v")}
                  value={this.state.cost_v}
                />
                {error("cost_v")}
              </div>

              <div className="form-group">
                <label>Select currency</label>
                <select
                  value={this.state.currencys}
                  code={this.state.currency_code}
                  onChange={e => this.handleChange(e, "currencys")}
                >
                  {this.state.currency_list.map((currency, i) => (
                    <option key={i} value={currency.id} code={currency.code}>
                      {currency.code}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          <div className="col_6">
            <div className="form-group">
              <label>
                Search Address or City or State(autofill) <b> * </b>
              </label>

              {/* <SearchAddressComp
                onChange={e => this.handleChange(e, "search_address")}
                search_address={this.state.search_address}
                onPlace={this.SearchInMap}
                placeholder="Search a location"
              /> */}
              <input
                type="text"
                id="search_address"
                onChange={e => this.handleChange(e, "search_address")}
                value={this.state.search_address}
                placeholder="Search a location"
              />

              {error("search_address")}
            </div>

            <input
              id="street_number"
              disabled={false}
              name="streetnumber"
              type="hidden"
            />
            <input id="route" disabled={true} name="route" type="hidden" />

            <input
              id="locality"
              disabled={true}
              name="locality"
              type="hidden"
            />

            <input
              id="administrative_area_level_1"
              disabled={true}
              name="state"
              type="hidden"
            />

            <input
              id="postal_code"
              disabled={true}
              name="postal_code"
              type="hidden"
            />

            <input id="country" disabled={true} name="country" type="hidden" />

            <input
              id="latitude"
              disabled={true}
              name="latitude"
              value={this.state.latitude}
              type="hidden"
            />

            <input
              id="longitude"
              disabled={true}
              name="longitude"
              value={this.state.longitude}
              type="hidden"
            />

            <div className="form-group">
              <label>
                Address <b> * </b>
              </label>
              <input
                type="text"
                onChange={e => this.handleChange(e, "address")}
                value={this.state.address}
                placeholder="Address"
              />
              {error("address")}
            </div>
          </div>

          <div
            className="form-group"
            id="map"
            style={{ width: "100%", height: "250px" }}
          ></div>

          <div className="col_4">
            <div className="form-group">
              <label>
                Country <b> * </b>
              </label>
              <CountrylistComp
                handleCountry={this.handleCountry}
                country_id={this.state.country_id}
              />
              {error("country_id")}
            </div>
            <div className="form-group">
              <label>
                City <b> * </b>
              </label>
              <CitylistComp
                handleCity={this.handleCity}
                city_id={this.state.city_id}
                country_id={this.state.country_id}
              />
              {error("city_id")}
            </div>

            <div className="form-group">
              <label>
                Zip <b> * </b>
              </label>
              <input
                type="text"
                onChange={e => this.handleChange(e, "zip_v")}
                value={this.state.zip_v}
                placeholder="Zip"
              />
              {error("zip_v")}
            </div>
          </div>

          <div className="form-group">
            <label>
              Description of Venue and Space <b> * </b>
            </label>
            <textarea
              onChange={e => this.handleChange(e, "description_v")}
              value={this.state.description_v}
            />
            {error("description_v")}
            <span>
              <b>Hint:</b> Try to make this as inviting and warm as possible.
              Imagine you should buy this place, what pros are there in your
              venue or space, what does the color do, and what characterizes
              your place.
            </span>
          </div>

          <div className="col_6">
            <div className="form-group check_list">
              <h4>
                Days of the Week <b> * </b>
              </h4>

              <label>
                <input
                  type="checkbox"
                  onChange={e => this.handleCheck(e, "is_alldays_checked")}
                  checked={this.state.is_alldays_checked ? "checked" : ""}
                />
                <span className="checkmark" />
                24/7
              </label>

              <div className={this.state.is_alldays_checked ? "d-n" : "d-b"}>
                <div className="or">
                  <span>OR</span>
                </div>

                <div className="check_week">
                  <label className="check_all">
                    <input
                      type="checkbox"
                      checked={this.state.checkAll_oh ? "checked" : ""}
                      onChange={e => this.handleCheckDays(e, "check_all")}
                    />
                    <span className="checkmark" />
                    Check All
                  </label>

                  <div className="select_box">
                    <select
                      onChange={e => this.handleCheckDayHours(e, "f_time")}
                      value={this.state.f_time}
                      disabled={!this.state.checkAll_oh}
                    >
                      <option value={0}>From</option>
                      {this.state.time_list.map((time, i) => (
                        <option key={i} value={time}>
                          {time}
                        </option>
                      ))}
                    </select>
                    <select
                      onChange={e => this.handleCheckDayHours(e, "t_time")}
                      value={this.state.t_time}
                      disabled={!this.state.checkAll_oh}
                    >
                      <option value={0}>To</option>
                      {this.state.time_list
                        .filter(time => time > this.state.f_time)
                        .map((time, i) => (
                          <option key={i} value={time}>
                            {time}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                {this.state.days.map((days, i) => {
                  return (
                    <div key={i} className="check_week open_hours">
                      <label>
                        <input
                          type="checkbox"
                          index={i}
                          checked={this.state.day_checked[i] ? "checked" : ""}
                          className="checked_week"
                          onChange={e => this.handleCheckDays(e, "check_index")}
                        />
                        <span className="checkmark" />
                        {days}
                      </label>

                      <div className="select_box">
                        <select
                          className="ff_time"
                          index={i}
                          onChange={e => this.handleCheckDayHours(e, "from")}
                          value={this.state.cf_time[i]}
                          disabled={!this.state.day_checked[i]}
                        >
                          <option value={0}>From</option>
                          {this.state.time_list.map((time, i) => (
                            <option key={i} value={time}>
                              {time}
                            </option>
                          ))}
                        </select>
                        <select
                          className="tt_time"
                          index={i}
                          onChange={e => this.handleCheckDayHours(e, "to")}
                          value={this.state.ct_time[i]}
                          disabled={!this.state.day_checked[i]}
                        >
                          <option value={0}>To</option>
                          {this.state.time_list
                            .filter(time => time > this.state.cf_time[i])
                            .map((time, i) => (
                              <option key={i} value={time}>
                                {time}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  );
                })}
                {error("vcheckhours")}
              </div>
            </div>

            <div className="form-group check_list">
              <h4>
                Any bonus facilities at your venue? <b> * </b>
              </h4>
              <label className="venue_all">
                <input
                  type="checkbox"
                  checked={this.state.checkAll ? "checked" : ""}
                  onChange={e => this.handleCheckAmenity(e, "check_all")}
                />
                <span className="checkmark" />
                Check All
              </label>

              <div className="venue">
                {this.state.amenity_list.map((amenity, i) => (
                  <label key={i}>
                    <input
                      type="checkbox"
                      className="amenity"
                      value={amenity.id}
                      onChange={e => this.handleCheckAmenity(e, "check_each")}
                      checked={
                        this.state.amenity_checked &&
                        this.state.amenity_checked.includes(amenity.id)
                          ? "checked"
                          : ""
                      }
                    />
                    <span className="checkmark" />
                    {amenity.title}
                  </label>
                ))}
              </div>
              {error("vcheckbox")}
            </div>
          </div>
        </div>

        <div className="button">
          <div className="prev_button">
            <button onClick={() => this.buttonStep("prev")}>
              <span>&#x276E;</span>
              {window.innerWidth < 767 ? "PREV" : "PREVIOUS STEP"}
            </button>
          </div>

          <div className="next_button">
            <button onClick={() => this.buttonStep("next")}>
              {window.innerWidth < 767 ? "NEXT" : "NEXT STEP"}
              <span>&#x276F;</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
